import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from '@/components/feature/Logo';
import HeroBanner from './components/HeroBanner';
import SpotCard from './components/SpotCard';
import MarketSection from './components/MarketSection';
import PledgeBanner from './components/PledgeBanner';

export default function HomePage() {
  const navigate = useNavigate();
  const { t } = useTranslation(['common', 'home']);

  const features = [
    {
      icon: 'ri-flashlight-line',
      label: t('home:quickReserve'),
      desc: t('home:quickReserveDesc'),
      path: '/lock-price',
    },
    {
      icon: 'ri-file-list-3-line',
      label: t('home:reserveOrders'),
      desc: t('home:reserveOrdersDesc'),
      path: '/orders',
    },
    {
      icon: 'ri-task-line',
      label: t('home:performManage'),
      desc: t('home:performManageDesc'),
      path: '/performance',
    },
    {
      icon: 'ri-bank-card-line',
      label: t('home:performPay'),
      desc: t('home:performPayDesc'),
      path: '/payment',
    },
  ];

  return (
    <div className="min-h-screen bg-brown-50 pb-28">
      {/* Header */}
      <div className="sticky top-0 z-40 bg-brown-50/95 backdrop-blur-md px-5 py-3 pt-safe flex items-center justify-between border-b border-gold-100/30">
        <Logo
          size="md"
          showSubtitle
          textColor="text-brown-900"
          iconBg="bg-gold-500"
          iconColor="text-brown-950"
          subtitle="JIN AN CHINA"
        />
        <div className="flex items-center gap-4">
          <button className="w-8 h-8 flex items-center justify-center text-brown-600 cursor-pointer">
            <i className="ri-notification-3-line text-xl"></i>
          </button>
          <button className="w-8 h-8 flex items-center justify-center text-brown-600 cursor-pointer">
            <i className="ri-menu-3-line text-xl"></i>
          </button>
        </div>
      </div>

      {/* Hero Banner */}
      <HeroBanner />

      {/* Spot Card */}
      <SpotCard />

      {/* Feature Grid */}
      <div className="px-3 mt-4">
        <div className="grid grid-cols-4 gap-2 bg-white rounded-xl p-4 border border-gold-50">
          {features.map((f) => (
            <button
              key={f.label}
              onClick={() => navigate(f.path)}
              className="flex flex-col items-center gap-1.5 cursor-pointer"
            >
              <div className="w-10 h-10 rounded-full bg-gold-50 flex items-center justify-center">
                <span className="w-5 h-5 flex items-center justify-center text-gold-500">
                  <i className={`${f.icon} text-lg`}></i>
                </span>
              </div>
              <span className="text-brown-800 text-xs font-medium">
                {f.label}
              </span>
              <span className="text-brown-400 text-[10px]">{f.desc}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Market Prices */}
      <MarketSection />

      {/* Jinan Pledge */}
      <PledgeBanner />
    </div>
  );
}